import axios from "axios";

const baseURL = {
  development: 'https://j6po1ll8lj.execute-api.ap-south-1.amazonaws.com/dev',
  production: 'https://fxj50ba4kh.execute-api.ap-south-1.amazonaws.com/prod',
  local: 'http://localhost:8080/dev'
};


export default axios.create({ baseURL: baseURL[process.env.REACT_APP_ENV || 'production'] });